/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PatientDemographic } from '../../models/patient-demographic';

export interface PatientDemographicsUpdate$Params {
  patientId: string | null;
  practiceId?: string | null;
      body: PatientDemographic
}

export function patientDemographicsUpdate(http: HttpClient, rootUrl: string, params: PatientDemographicsUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, patientDemographicsUpdate.PATH, 'put');
  if (params) {
    rb.path('patientId', params.patientId, {});
    rb.query('practiceId', params.practiceId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/octet-stream', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

patientDemographicsUpdate.PATH = '/api/PatientDemographics/{patientId}';
